import React from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const MergingForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = "#C62828";

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, mb: 1, color: red }}
      >
        Asset Merging
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.enabled || false}
                onChange={(e) => onChange("enabled", e.target.checked)}
              />
            }
            label="Enabled"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Max Merged Sets"
            type="number"
            value={config.maxMergedSets || ""}
            onChange={(e) => onChange("maxMergedSets", e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Base Type Requirements"
            value={config.baseTypeRequirements || ""}
            onChange={(e) => onChange("baseTypeRequirements", e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Type Exclusions"
            value={config.typeExclusions || ""}
            onChange={(e) => onChange("typeExclusions", e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MergingForm;
